import type { ActionCodeSettings } from "firebase/auth";

const CANONICAL_PRODUCTION_ORIGIN = "https://amazing.wedding";

function isAmazingWeddingHost(hostname: string): boolean {
  return (
    hostname === "amazing.wedding" ||
    hostname === "www.amazing.wedding" ||
    hostname.endsWith(".amazing.wedding")
  );
}

/** Origin for auth email continue URLs (must be an authorized domain in Firebase Console). */
export function authEmailContinueOrigin(): string {
  if (typeof window !== "undefined" && window.location.origin) {
    if (isAmazingWeddingHost(window.location.hostname)) {
      return CANONICAL_PRODUCTION_ORIGIN;
    }
    return window.location.origin;
  }
  const configured = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "";
  if (configured === "amazing.wedding" || configured.endsWith(".amazing.wedding")) {
    return CANONICAL_PRODUCTION_ORIGIN;
  }
  if (configured.includes("firebaseapp.com") || configured.includes("web.app")) {
    return `https://${configured}`;
  }
  return CANONICAL_PRODUCTION_ORIGIN;
}

/**
 * Continue URL after the user completes password reset from the email link.
 * The link target itself is configured in Firebase Console → Templates → Password reset
 * → Customize action URL (`https://amazing.wedding/reset/confirm`). Do not set linkDomain
 * here unless a Hosting link domain is also configured — otherwise Firebase returns
 * auth/invalid-hosting-link-domain and the email is never sent.
 */
export function buildPasswordResetActionCodeSettings(): ActionCodeSettings {
  const origin = authEmailContinueOrigin();
  return {
    url: `${origin}/login?reset=done`,
    handleCodeInApp: false,
  };
}

/** Continue URL after the user verifies their email from the registration link. */
export function buildEmailVerificationActionCodeSettings(): ActionCodeSettings {
  const origin = authEmailContinueOrigin();
  return {
    url: `${origin}/app/dashboard`,
    handleCodeInApp: false,
  };
}
